import { useEffect, useState } from 'react';

import { DateRange } from 'react-date-range';
import es from 'date-fns/locale/es';

import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';

const DateFilterDialog = ({
    open, onClose, onApply, currentRange
}) => {
    const [range, setRange] = useState([{
        ...currentRange,
        key: 'selection'
    }]);
    const [isApplying, setIsApplying] = useState(false);

    useEffect(() => {
        if (!open)
            return;

        setRange([{
            ...currentRange,
            key: 'selection'
        }]);
    }, [currentRange, open]);

    const applyRange = async () => {
        setIsApplying(true);
        try {
            await onApply(range[0].startDate, range[0].endDate);
        } finally {
            setIsApplying(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Filtrar por fecha</DialogTitle>
            <DialogContent>
                <Box sx={{ border: '1px solid #e1e1e1', borderRadius: '3px' }}>
                    <DateRange
                        editableDateInputs
                        onChange={item => setRange([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={range}
                        locale={es}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button disabled={isApplying} onClick={onClose}>
                    Cancelar
                </Button>
                <Button disabled={isApplying} onClick={applyRange}>
                    {isApplying ? 'Filtrando…' : 'Filtrar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DateFilterDialog;
